/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { Box } from '@mui/material';
import React from 'react';
import { Hodograph } from './Hodograph';
import { HodographLegend } from './HodographLegend';
import type { SoundingFeature } from '../../api/edr-api/types';

export interface HodographCollectionProps {
  data: SoundingFeature[][];
}

export const HodographCollection: React.FC<HodographCollectionProps> = ({
  data,
}) => {
  return (
    <Box
      sx={{
        padding: '5px',
      }}
    >
      <Hodograph data={data} />
      <HodographLegend />
    </Box>
  );
};
